import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { paymentService } from 'services/PaymentService';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import CardPage from './CardPage/index';
import { cartService } from 'services/CartService';
import { postBackService } from 'services/PostBackService';
import { Observable } from 'rxjs/Observable';
import { showError } from 'shared/services/dialog';
import * as queryString from 'query-string';
import { IProductConfig } from 'interfaces/IProductData';
import { Helmet } from 'react-helmet';
import BoletoPage from './BoletoPage/index';
import BoletoWidgetPage from './BoletoWidgetPage/index';
import CardWidgetPage from './CardWidgetPage/index';
import { parameterService } from 'services/ParameterService';
import { pixelService } from 'services/PixelService';
import { Cookies } from 'react-cookie';
import { enNormalizedPaymentType } from 'enums/enPaymentMethod';
import { invoiceService } from 'services/InvoiceService';
import { WithRouter } from 'shared/decorators/withRouter';
import { scriptsService } from 'services/ScriptsService';
import { formatScripts } from 'functions';
import { enParameters } from 'enums/enParameters';

interface IState extends IStateBase {
  infos: IThankYouPage;
  config: IProductConfig;
}
const cookie = new Cookies();

const hiddenPixel = {
  border: 0,
  width: 0,
  height: 0,
  opacity: 0
};

@WithRouter()
export default class ThankYouPage extends BaseComponent<IState>{

  constructor(props: any) {
    super(props);
    this.state = {
      infos: null,
      config: null
    };
  }

  hasBankslipParameter = () => {
    const qsParameters = queryString.parse(window.location.search);
    return !!qsParameters['bs'];
  }

  componentDidMount() {
    history.pushState(null, null, location.href);

    window.onpopstate = function (event) {
      history.go(1);
    };

    this.observeState({ config: null }, cartService.getConfig());

    if (paymentService.hasPayment()) {
      Observable.combineLatest(
        paymentService.getPaymentResult().loader(),
        cartService.getCart(),
        paymentService.getCart()
      )
        .switchMap(([result, cart, payment]) => {
          return Observable.of({
            producerIframe: result.thankyouUrl,
            paymentMethod: result.paymentMethod,
            isFree: result.paymentMethod === enNormalizedPaymentType.FREE ? true : false,
            bankslipCode: result.bankslipCode,
            bankslipUrl: result.bankslipUrl,
            imgProduct: cart.config.logo,
            producerName: cart.products[0].producerName,
            producerEmail: cart.products[0].producerEmail,
            isDefault: result.thankyouUrl ? false : true,
            transactionKey: cart.transactionKey,
            userEmail: payment.email,
            templateId: cart.config.template.id
          } as IThankYouPage);
        })
        .filter(() => !this.hasBankslipParameter())
        .first()
        .bindComponent(this)
        .subscribe((infos) => {
          infos.displayThankyou = false;
          this.setState({ infos });
        });

      paymentService.getPaymentResult()
        .switchMap((result) => {
          return Observable.combineLatest(
            Observable.of(result),
            invoiceService.create(result.key)
              .retry(20)
              .logError());
        })
        .filter(() => !this.hasBankslipParameter())
        .filter(([result]) => !!result.thankyouUrl)
        .first()
        .bindComponent(this)
        .subscribe(
          ([result, params]) => {
            const { infos } = this.state;

            postBackService.postParams(params, result.thankyouUrl, result.key);
            infos.producerIframe = postBackService.getParams(params, result.thankyouUrl, result.key);

            cookie.set(`postget_${result.key}`, true, {
              maxAge: 259200
            });

            infos.displayThankyou = true;

            this.setState({ infos });
          },
          () => {
            const { infos } = this.state;

            infos.displayThankyou = true;

            this.setState({ infos });
          }
        );

    } else {
      const hash = this.props.location.pathname.replace(/^\/+|\/+$/gi, '').split('/').pop();

      parameterService.getAll().take(1)
        .switchMap((paramters) => paymentService.loadPaymentByHash(hash, paramters).loader())
        .catch(err => {
          return showError(err).switchMap(r => Observable.empty<IThankYouPage>());
        })
        .do((infos) => {
          infos.displayThankyou = false;
          infos.isDefault = !infos.producerIframe;

          this.setState({ infos });
          pixelService.setPixel({ ...infos.pixel } || {});
        })
        .switchMap((infos) => {
          const postback$ = cookie.get(`postget_${hash}`)
            ? Observable.of(null)
            : invoiceService.create(hash)
              .retry(20)
              .logError()
              .catch(() => Observable.of(null));

          return Observable.combineLatest(Observable.of(infos), postback$);
        })
        .subscribe(([infos, params]) => {
          infos.displayThankyou = true;

          if (!!infos.scripts && !parameterService.getSync(enParameters.bs)) {
            const thankyouScripts = formatScripts(infos.scripts);
            scriptsService.setScripts(thankyouScripts);
          }

          if (params) {
            postBackService.postParams(params, infos.producerIframe, hash);
            infos.producerIframe = postBackService.getParams(params, infos.producerIframe, hash);

            cookie.set(`postget_${hash}`, true, {
              maxAge: 259200
            });
          }

          this.setState({ infos });
        });
    }

  }

  boletoPage = (id: number, infos: IThankYouPage) => {
    return id == 16 ? <BoletoWidgetPage infos={infos} /> : <BoletoPage infos={infos} />;
  }

  cardPage = (id: number, infos: IThankYouPage) => {
    return id == 16 ? <CardWidgetPage infos={infos} /> : <CardPage infos={infos} />;
  }

  render() {

    if (!this.state.infos) {
      return null;
    }

    const { infos, config } = this.state;

    return (
      <div>

        <Helmet>
          <html className={'theme_thankyou_' + (!!config ? config.template.id : 18)} />
        </Helmet>
        {infos.paymentMethod === enNormalizedPaymentType.BANKSLIP ?
          this.boletoPage(!!config ? config.template.id : 18, infos) :
          this.cardPage(!!config ? config.template.id : 18, infos)
        }
        <div id='post-get' />
        <iframe style={hiddenPixel} id='post-params' name='post-params' />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/index.tsx